/** @format */

import dot from 'dot-object';

/**
 * Depreciated, use the error.jsx handlers instead of parsing this upfront
 * @param responseBody
 * @returns {any}
 */
export default responseBody => {
    let errorMessage = {};
    let error = '';
    if (responseBody && typeof responseBody.message != 'undefined') {
        error = responseBody.message;
    } else {
        error = responseBody;
    }

    try {
        errorMessage = JSON.parse(error);
        errorMessage.message = Object.values(dot.dot(JSON.parse(error))).join(' AND ');
    } catch (e) {
        console.log(e);
        if (!error) {
            errorMessage = {message: 'Unparsable Error'};
        } else {
            errorMessage = {message: error};
        }
    }

    errorMessage.toString = () => errorMessage.message;

    return errorMessage;
};
